import { call, put, takeEvery } from 'redux-saga/effects';

import Api from '../lib/Api';

import { FETCH_SKILLS_REQUESTED } from '../store/skills/actionTypes';
import {
  fetchSkillsFailed,
  fetchSkillsSucceeded
} from '../store/skills/actions';

const _getUsersRequested = () => {
  return Api.getSkillsList()
    .then((response) => response)
    .catch((e) => e.response);
};

function* fetchSkills() {
  try {
    const response = yield call(_getUsersRequested);
    yield put(fetchSkillsSucceeded({ skills: response.data.data }));
  } catch (error) {
    yield put(fetchSkillsFailed(error));
  }
}

function* SkillsSaga() {
  yield takeEvery(FETCH_SKILLS_REQUESTED, fetchSkills);
}

export default SkillsSaga;



// WEBPACK FOOTER //
// ./src/saga/skills.js